/**
 * Genera un slug SEO-friendly a partir de un texto.
 * Ej: "MG ZS 2025 Automático" → "mg-zs-2025-automatico"
 */
export const toSlug = (text) =>
  (text || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')  // elimina tildes/diacríticos
    .replace(/[^a-z0-9]+/g, '-')      // todo lo no alfanumérico → guión
    .replace(/^-|-$/g, '');           // quita guiones al inicio/fin

/**
 * Codifica un ID numérico a base36.
 * Ej: 2125066253 → "z57jm5"
 */
export const toBase36 = (id) => parseInt(id).toString(36);

/**
 * Decodifica un código base36 al ID numérico original.
 * Ej: "z57jm5" → 2125066253
 */
export const fromBase36 = (code) => parseInt(code, 36);

/**
 * Genera el parámetro de URL completo para un vehículo.
 * Ej: { title: "MG ZS 2025", id: 2125066253 } → "mg-zs-2025-z57jm5"
 */
export const vehicleUrlParam = (entry) => {
  const slug = toSlug(entry.title || 'vehiculo');
  const code = toBase36(entry.id);
  return `${slug}-${code}`;
};

/**
 * Extrae el ID numérico del parámetro de URL.
 * El código base36 es siempre el último segmento separado por guión.
 * Ej: "mg-zs-2025-z57jm5" → 2125066253
 */
export const parseVehicleId = (slugParam) => {
  if (!slugParam) return null;
  const parts = slugParam.split('-');
  const code = parts[parts.length - 1];
  const id = fromBase36(code);
  return isNaN(id) ? null : id;
};
